'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { attachSubComponents, getChildByType, InternalProvider, isComponentType, useComponentDeprecation } from '../../../util';
import { Header, Footer } from '../common';
import { StyledUnorderedList, StyledList } from './elements';
import { ListItem, ListItemContext } from './components';

/**
 * @deprecated
 */
export const UnorderedList = attachSubComponents('UnorderedList', /*#__PURE__*/React.forwardRef(({
  children,
  isCard = false,
  isHorizontal = false,
  hasDividers = false,
  hasIcons = false,
  isSpacingCompact = false,
  maxItemsPerRow = 4,
  ...rest
}, fRef) => {
  useComponentDeprecation({
    name: 'UnorderedList',
    alternative: 'List',
    version: '5'
  });
  const ListHeader = getChildByType(children, Header);
  const ListFooter = getChildByType(children, Footer);
  const ListItems = React.Children.toArray(children).filter(element => isComponentType(element, ListItem));
  const itemsPerRow = ListItems.length < maxItemsPerRow ? ListItems.length : maxItemsPerRow;
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(StyledList, _extends({
    isCard: isCard,
    isHorizontal: isHorizontal,
    ref: fRef,
    isSpacingCompact: isSpacingCompact,
    hasDividers: hasDividers,
    maxItemsPerRow: itemsPerRow
  }, rest), ListHeader, /*#__PURE__*/React.createElement(StyledUnorderedList, null, /*#__PURE__*/React.createElement(ListItemContext.Provider, {
    value: {
      isCard,
      hasDividers,
      hasIcons,
      isSpacingCompact,
      isHorizontal
    }
  }, ListItems)), ListFooter));
}), {
  Header,
  ListItem,
  Footer
});